
import React, {useState} from 'react';


function App(props) {  

    return (
        <div className="">
            <div  id={props.id} className="hashtag text-underline text-title">{props.title}</div> 
        </div>
    );
}
    
    export default App;